
import styled from 'styled-components'

// Campo sobre superficie CLARA: contorno `borderField` (3.39:1), texto
// `textPrimary`, placeholder `textSecondary`. O foco usa `:focus-within`
// porque quem recebe o foco e o <input> interno, nao o container.
export const Container = styled.div`
  width: 90%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-left: 12px;
  margin-bottom: 12px;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.borderField};
  border-radius: 10px;
  transition: border-color 0.2s;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.accent};
  }
`;

export const TInput = styled.input`
  width: 90%;
  height: 100%;
  font-size: 15px;
  color: ${({ theme }) => theme.colors.textPrimary};
  border: none;
  background-color: transparent;
  padding-left: 12px;
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`
